import { useGetUserInfo } from "hooks/useGetUserInfo";
import { useMemo } from "react";


export const useHasPermission = () => {
    const { userInfo } = useGetUserInfo();

    const hasPermission = (permission: string): boolean => {
        if (!userInfo) return false;

        if (userInfo.recruiter?.is_corporate) {
            return true;
        }
        const globalPermissions = userInfo.permissions || [];

        const teamPermissions = userInfo.team_permissions || [];

        const allPermissions = [...globalPermissions, ...teamPermissions];

        return allPermissions.includes(permission);
    };

    return { hasPermission };
};

export const useCheckPermission = (permission: string) => {
  const { userInfo } = useGetUserInfo();
    const hasPermission = useMemo(() => {


      //============
    if (process.env.NODE_ENV === 'development') {
      console.log(`🔍 [DEV] Granting permission: ${permission}`);
      return true;
    }
        //==============
        

    if (!userInfo) return false;
    
    const permissions = userInfo.permissions || [];
    return permissions.includes(permission);
  }, [userInfo, permission]);
  
  return hasPermission;
};